import React from "react";

import { PaginatedTable } from "../PaginatedTable";
import { EntrataUsersTableBody } from "./EntrataUsersTableBody";
import { EntrataUsersTableHead, headCells } from "./EntrataUsersTableHead";

import { useEntrataUsers } from "./useEntrataUsers";

export const EntrataUsersTable = () => {
  const { users, loading, loadUsers } = useEntrataUsers();

  return (
    <PaginatedTable data={users} title="Entrata" isLoading={loading} fetchMore={loadUsers} colSpan={headCells.length}>
      <EntrataUsersTableHead />
      <EntrataUsersTableBody />
    </PaginatedTable>
  );
};
